<template>
    <section
        class="slice slice-trends-content"
        :class="{'slice-trends-content--grey': backgroundColor === 'grey'}"
        :data-slice-type="slice.slice_type"
        :data-slice-variation="slice.variation"
    >
        <div class="slice-content">
            <TrendsShape class="slice-trends-content__shape" />
            <div class="slice-trends-content__text">
                <TitleBrand :field="slice.primary.title" />
                <div class="slice-body">
                    <PrismicRichText :field="slice.primary.content" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {Content} from '@prismicio/client';
    import {getSliceComponentProps} from '@prismicio/vue';
    import {PrismicRichText} from '@prismicio/vue';
    import TitleBrand from '~/components/TitleBrand.vue';
    import TrendsShape from '~/components/trends/TrendsShape.vue';

    const props = defineProps(getSliceComponentProps<Content.TrendsContentSlice>(['slice', 'index', 'slices', 'context']));
    const backgroundColor = computed(() => props.slice.primary.backgroundColor);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .slice-trends-content {
        overflow: hidden;

        &--grey {
            background-color: var(--joy-color-neutral-20);
        }

        &__shape {
            position: absolute;
            top: 0;
            right: 0;
            width: 50%;

            @include mq.screen_md(min) {
                width: 754px;
                overflow: visible;
            }
        }
        &__text {
            position: relative;

            .slice-body h2 {
                padding-top: var(--joy-core-spacing-6);
                padding-bottom: var(--joy-core-spacing-8);
                font-family: var(--joy-font-family-title);
                font-weight: 500;
                font-size: 36px;

                @include mq.screen_lg(min) {
                    font-size: 52px;
                    padding-top: var(--joy-core-spacing-10);
                    padding-bottom: var(--joy-core-spacing-10);
                }
            }

            @include mq.screen_md(min) {
                padding-top: 100px;
                max-width: 900px;
            }
        }
    }
</style>
